<template>
  <Form
    :form-id="formId"
    :initial-values="initialValues"
    :class="{ dirty }"
  >
    <VPInput
      ref="nameRef"
      :disabled="disabled"
      input-id="name"
      label="Agent"
      placeholder="Add agent name"
      @blur="onSubmit"
    />
    <VPInput
      ref="emailRef"
      :disabled="disabled"
      input-id="email"
      label="Agent's Email"
      placeholder="Add agent's email"
      @blur="onSubmit"
    />
    <VPInput
      ref="agencyRef"
      :disabled="disabled"
      input-id="agencyName"
      label="Agency"
      placeholder="Add agency"
      @blur="onSubmit"
    />
  </Form>
</template>

<script setup lang="ts">
import { Form, useFormsStore } from 'vuniform';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import VPInput from '@/components/form/VPInput.vue';

const nameRef = ref<VPInput>(null);
const emailRef = ref<VPInput>(null);
const agencyRef = ref<VPInput>(null);

const formsStore = useFormsStore();

interface Props {
  formId: string;
  initialValues: unknown;
  disabled?: boolean;
}
const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'blur'): void;
  (e: 'save'): void;
}>();

const refs = [nameRef, emailRef, agencyRef];

const activeElement = ref<EventTarget | null>(null);

const focusChanged = (e: Event) => {
  activeElement.value = e.target;
};

onMounted(() => {
  document.addEventListener('focusin', focusChanged);
});
onBeforeUnmount(() => {
  document.removeEventListener('focusin', focusChanged);
});

const hasFocus = computed(() =>
  refs.some(r => r.value?.inputRef && activeElement.value && r.value?.inputRef === activeElement.value),
);

watch(hasFocus, (newValue, oldValue) => {
  if (oldValue && !newValue) {
    emit('blur');
  }
});

const dirty = computed(() => formsStore.isFormDirty(props.formId));

const onSubmit = () => {
  emit('save');
};
</script>
